import React from "react";
import { Box } from "@mui/material";

// Small uppercase label used above section titles, KPI tiles, page headers.
export default function Eyebrow({ children, color, sx, ...rest }) {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        fontSize: 10.5,
        fontWeight: 600,
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        lineHeight: 1.2,
        color: color || ((t) => t.palette.brand.goldDeep),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
